<template>
    <MainComponent
        v-if="hasPortfolioItems || isEditModeEnabled"
        :id="anchorsPageProfile.portfolioSection"
        data-testid="portfolio-item-porfolio"
        class="portfolio"
    >
        <template #title>
            <h2>{{ t('profile.section.book.title') }}</h2>
        </template>

        <template #title-action>
            <ClientOnly v-if="isEditModeEnabled">
                <VJoyIconButton
                    v-if="hasPortfolioItems"
                    href="/profile/portfolio"
                    data-testid="portfolio-item-porfolio-edition-link"
                    variant="ghost"
                    icon="pen"
                    size="small"
                    :label="$t('general.edit')"
                />
                <template #fallback>
                    <SectionActionSkeleton />
                </template>
            </ClientOnly>
        </template>

        <template #content>
            <div class="portfolio__galleria-wrapper" :class="{'portfolio__galleria-wrapper-nothing': !hasPortfolioItems}">
                <template v-if="loggedIn">
                    <LazyPortfolioGalleria
                        v-if="profile"
                        :portfolio-items="portfolio?.items || []"
                        :is-edit-mode-enabled="isEditModeEnabled"
                        :tracking="{enabled: !isEditModeEnabled, profileId: profile.profileId}"
                    />
                </template>
                <template v-else>
                    <div v-if="getFirstPortfolioItem" class="portfolio_fallback">
                        <MaltImg
                            :src="getFirstPortfolioItem.portfolioImageMaxImageUrl"
                            :title="getFirstPortfolioItem.title"
                            width="650"
                            height="650"
                            fit="inside"
                            class="portfolio__item image"
                            densities="1x"
                            loading="lazy"
                            alt=""
                        />
                    </div>
                </template>
            </div>
        </template>
    </MainComponent>
</template>
<script setup lang="ts">
    import {storeToRefs} from 'pinia';
    import {LazyPortfolioGalleria, MaltImg} from '#components';
    import {computed, useAuth, useTranslation} from '#imports';

    import {VJoyIconButton} from '@maltjoy/core-vue';
    import SectionActionSkeleton from '~/components/section/SectionActionSkeleton.vue';
    import {anchorsPageProfile} from '~/config/anchors';
    import {useProfileStore} from '~/store/profileStore';
    import {useSectionsVisibilityStore} from '~/store/sectionsVisibility';
    import MainComponent from './common/MainComponent.vue';

    const {t} = useTranslation();
    const {loggedIn} = useAuth();
    const profileStore = useProfileStore();
    const {portfolio, profile} = storeToRefs(profileStore);

    const {hasPortfolioItems} = storeToRefs(useSectionsVisibilityStore());

    const isEditModeEnabled = computed(() => profile?.value?.editMode || false);
    const getFirstPortfolioItem = computed(() => (hasPortfolioItems.value ? portfolio.value!.items[0] : undefined));
</script>
<style scoped lang="scss">
    .portfolio {
        &__galleria-wrapper,
        &__fallback {
            height: 375px;
            width: 100%;

            &-nothing {
                height: unset;
            }
        }

        &__item {
            max-height: 100%;
            max-width: 100%;

            &-selected {
                object-fit: contain;
                max-width: 100%;
                max-height: 100%;
            }

            &.image {
                object-fit: contain;
                height: auto;
            }

            &.thumbnail {
                height: 100px;
                object-fit: contain;
            }
            &.thumbnail--fullscreen {
                height: 150px;
            }

            &.video-player {
                height: 80%;
                width: 100%;
            }
        }

        &__fallback {
            display: flex;
            justify-content: center;
            align-items: center;

            .image {
                width: calc(100% - 170px);
            }
        }
    }
</style>
